// Date formatting utilities for DD-MM-YYYY format

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Safe multi-format display: ISO (with/without time) → DD-MM-YYYY,
// DD-MM-YYYY / DD/MM/YYYY pass through normalised. Never throws.
export const formatAnyDate = (v) => {
  if (!v) return '';
  const s = String(v).trim().slice(0, 10);
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  m = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (m) return `${m[1].padStart(2, '0')}-${m[2].padStart(2, '0')}-${m[3]}`;
  return String(v);
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  // Convert DD-MM-YYYY to YYYY-MM-DD for input fields
  if (dateString.includes('-') && dateString.split('-')[0].length === 2) {
    const [day, month, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
  }
  return dateString;
};

export const parseInputDate = (inputDate) => {
  // Convert YYYY-MM-DD to DD-MM-YYYY for storage/display
  if (!inputDate) return '';
  const [year, month, day] = inputDate.split('-');
  return `${day}-${month}-${year}`;
};

export const sortByDeliveryDate = (a, b) => {
  // Sort by delivery date (earliest first)
  const dateA = a.delivery_date ? parseDateString(a.delivery_date) : new Date('9999-12-31');
  const dateB = b.delivery_date ? parseDateString(b.delivery_date) : new Date('9999-12-31');
  return dateA - dateB;
};

const parseDateString = (dateString) => {
  if (!dateString) return new Date('9999-12-31');
  
  // Handle DD-MM-YYYY format
  if (dateString.includes('-') && dateString.split('-')[0].length === 2) {
    const [day, month, year] = dateString.split('-');
    return new Date(`${year}-${month}-${day}`);
  }
  
  // Handle YYYY-MM-DD format
  return new Date(dateString);
};
